import React, { useState, useRef, useEffect } from "react";
import cx from "classnames";
import styles from "../scss/AFSubmit.module.scss";
import Rating1 from "../assets/icons/rating-1-very-good.svg";
import Rating2 from "../assets/icons/rating-2-good.svg";
import Rating3 from "../assets/icons/rating-3-fair.svg";
import Rating4 from "../assets/icons/rating-4-poor.svg";
import Rating5 from "../assets/icons/rating-5-bad.svg";
import Input from "../../common/components/Forms/Input/Input";

enum ratingType {
    RATING1 = "1",
    RATING2 = "2",
    RATING3 = "3",
    RATING4 = "4",
    RATING5 = "5"
}

export interface IRatings {
    experienceRating?: string;
    experienceComments?: string;
}

interface IAFRateExperienceProps {
    data?: IRatings;
    ratingChanges: (rating: IRatings) => void;
}

const AFRateExperience: React.FC<IAFRateExperienceProps> = (props) => {
    const { data, ratingChanges } = props;

    const [isReady, setIsReady] = useState(false);
    const [ratings, setRatings] = useState("");
    const [comments, setComments] = useState("");
    const [experienceRates, setExperienceRates] = useState<IRatings>();
    const bottomRef = useRef(null);

    const handleRating = (rate): void => {
        if (ratings) {
            setRatings("");
            setComments("");
            handleChanges({});
            return;
        }
        setRatings(rate);
        handleChanges({
            ...experienceRates,
            experienceRating: rate
        });
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const handleComment = (value): void => {
        if (value.length <= 500) {
            setComments(value);
            handleChanges({
                ...experienceRates,
                experienceComments: value
            });
        }
    };

    const handleChanges = (ratings: IRatings): void => {
        setExperienceRates(ratings);
        ratingChanges(ratings);
    };

    useEffect(() => {
        handleRating(data?.experienceRating || "");
        handleComment(data?.experienceComments || "");
    }, [data]);

    return (
        <React.Fragment>
            <div className={cx(styles["af-ratings"])}>
                <div className={cx(styles["ratings-title-label"])}>
                    Rate your experience
                </div>

                <div className={styles["af-ratings-content"]}>
                    <div className={styles["af-ratings-selection"]}>
                        <img
                            alt="Rating 1"
                            className={cx(
                                ratings && ratings !== ratingType.RATING1
                                    ? styles["deselect"]
                                    : ""
                            )}
                            src={Rating5}
                            onClick={() => handleRating(ratingType.RATING1)}
                        />
                        <img
                            alt="Rating 2"
                            className={cx(
                                ratings && ratings !== ratingType.RATING2
                                    ? styles["deselect"]
                                    : ""
                            )}
                            src={Rating4}
                            onClick={() => handleRating(ratingType.RATING2)}
                        />
                        <img
                            alt="Rating 3"
                            className={cx(
                                ratings && ratings !== ratingType.RATING3
                                    ? styles["deselect"]
                                    : ""
                            )}
                            src={Rating3}
                            onClick={() => handleRating(ratingType.RATING3)}
                        />
                        <img
                            alt="Rating 4"
                            className={cx(
                                ratings && ratings !== ratingType.RATING4
                                    ? styles["deselect"]
                                    : ""
                            )}
                            src={Rating2}
                            onClick={() => handleRating(ratingType.RATING4)}
                        />
                        <img
                            alt="Rating 5"
                            className={cx(
                                ratings && ratings !== ratingType.RATING5
                                    ? styles["deselect"]
                                    : ""
                            )}
                            src={Rating1}
                            onClick={() => handleRating(ratingType.RATING5)}
                        />
                    </div>

                    {ratings && ratings !== ratingType.RATING5 && (
                        <div className={styles["af-bank-signature"]}>
                            <label
                                className={styles["af-bank-signature--label"]}
                                htmlFor="How could your experience have been better?">
                                How could your experience have been better?
                            </label>
                            <Input
                                id="How could your experience have been better?"
                                name="How could your experience have been better?"
                                type="textarea"
                                value={comments}
                                rows={4}
                                maxlength={500}
                                onChange={(e) => {
                                    handleComment(e.target.value);
                                }}
                            />
                            <div className={styles["af-bank-signature--span"]}>
                                {500 - comments.length} characters remaining
                            </div>
                        </div>
                    )}
                </div>
                <div ref={bottomRef} />
            </div>
        </React.Fragment>
    );
};

export default AFRateExperience;
